<template>
  <div class="container" :style="{ 'background-image': `url(${require('@/assets/bg_yh.jpg')})` }">
    <div class="map-chart" id="mapEchart"></div>
    <div class="top-box">
      <img class="top-img" src="../assets/top_img.png" />
      <div class="top-info">
        <div class="top-left">
          <img src="../assets/logo.png" />
          <div>数字展览可视化管理系统</div>
        </div>
        <div class="top-title" :title="data.title">{{ data.title }}</div>
        <div class="top-right">
          <div class="time">{{ time }}</div>
          <div class="date">
            <div>
              {{date}}
            </div>
            <div>
              {{week}}
            </div>
          </div>
          <div class="logout" @click="logout">注销</div>
        </div>
      </div>
      <div class="top-desc">展览时间：{{data.startDate}}至{{ data.endDate }}</div>
    </div>
    <div class="left-top-data">
      <div class="top-item">
        <div class="item-left">
          <img src="../assets/z_zl.png" />
        </div>
        <div class="item-right">
          <div class="right-head">观展总量</div>
          <div class="right-data"><span class="strong">
              <CountTo :startVal="view" :endVal="viewTo" :duration="2000" />
            </span>人次</div>
        </div>
      </div>
      <div class="top-item">
        <div class="item-left">
          <img src="../assets/z_sc.png" />
        </div>
        <div class="item-right">
          <div class="right-head">观展总时长</div>
          <div class="right-data"><span class="strong">
              <CountTo :startVal="viewTimes" :endVal="viewTimesTo" :duration="2000" />
            </span>分钟</div>
        </div>
      </div>
    </div>
    <div class="left-mid-data">
      <div class="mid-item">
        <img src="../assets/y_fx_icon@2x.png" />分享<span class="strong">
          <CountTo :startVal="share" :endVal="shareTo" :duration="2000" />
        </span>人次
      </div>
      <div class="mid-item">
        <img src="../assets/y_dz_icon@2x.png" />点赞<span class="strong">
          <CountTo :startVal="like" :endVal="likeTo" :duration="2000" />
        </span>人
      </div>
      <div class="mid-item">
        <img src="../assets/y_pl_icon@2x.png" />评论<span class="strong">
          <CountTo :startVal="comment" :endVal="commentTo" :duration="2000" />
        </span>条
      </div>
    </div>
    <div class="right-top-data data-box">
      <div class="bottom-header data-header">热度排行<span>Popularity Ranking</span></div>
      <div class="content-header">
        <img src="../assets/title_zp.png" />
        <div class="header-title">作品排行</div>
      </div>
      <div class="right-top-content">
        <div class="content-item" v-for="(item,index) in worksRank">
          <div class="index">{{ index+1 }}</div>
          <img :src="item.coverUrl" />
          <div class="title">{{ item.title }}</div>
          <div class="hot">{{item.labels}}</div>
        </div>
      </div>
      <div class="content-header">
        <img src="../assets/title_ysj.png" />
        <div class="header-title">艺术家排行</div>
      </div>
      <div class="right-top-content">
        <div class="content-item" v-for="(item,index) in userRank">
          <div class="index">{{ index+1 }}</div>
          <img class="avatar" :src="item.coverUrl" />
          <div class="title">{{ item.title }}</div>
          <div class="hot">{{item.labels}}</div>
        </div>
      </div>
    </div>
    <div class="left-bottom-data data-box">
      <div class="data-header">观展数据分析<span>Data Analysis</span></div>
      <div class="data-content">
        <div class="data-item">
          <div class="item-title">观展频次</div>
          <div class="item-content">
            <div class="item-box" v-for="(item, index) in viewNum" :key="index + 1">
              <div class="num" style="width: .625rem;">{{ item.num }}</div>
              <div class="data">{{ item.data }}%</div>
              <div class="bar-box">
                <div class="bar" :style="{ width: item.data + '%' }" :class="'bar' + index"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="data-item">
          <div class="item-title">观展时长</div>
          <div class="item-content">
            <div class="item-box" v-for="(item, index) in viewTime" :key="index + 1">
              <div class="num" style="width: .8rem;">{{ item.time }}</div>
              <div class="data">{{ item.data }}%</div>
              <div class="bar-box">
                <div class="bar" :style="{ width: item.data + '%' }" :class="'bar' + index"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <img class="bottom-img" src="../assets/bottom_img.png" />
      <div class="bottom-menu-box">
        <div class="bottom-menu">
          <div class="menu-item active">
            <img src="../assets/menu_yh_on.png" />
            <div>运营数据</div>
          </div>
          <div class="menu-item">
            <router-link :to="{ name: 'OperateData' }">
              <img src="../assets/menu_yy_off.png" />
              <div>展览数据</div>
            </router-link>
          </div>
          <!-- <div class="menu-item">
            <img src="../assets/menu_zg_off.png" />
            <div>展览数据</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import * as echarts from "echarts";
import "echarts-gl";
import JSON from "../assets/china.json";
import CountTo from 'vue-count-to';
import md5 from 'js-md5'
import https from '../https.js'
export default {
  name: 'UserData',
  components: {
    CountTo
  },
  data() {
    return {
      data: [],
      view: 0,
      viewTo: 0,
      viewTimes: 0,
      viewTimesTo: 0,
      share: 0,
      shareTo: 0,
      like: 0,
      likeTo: 0,
      comment: 0,
      commentTo: 0,
      time: "",
      date: "",
      week: "",
      viewNum: [
        { "num": "1次", "data": "0" },
        { "num": "2次", "data": "0" },
        { "num": "3次", "data": "0" },
        { "num": "4次", "data": "0" },
        { "num": "5次", "data": "0" },
        { "num": "5次以上", "data": "0" },
      ],
      viewTime: [
        { "time": "1分钟以内", "data": "0.00" },
        { "time": "1-5分钟", "data": "0.00" },
        { "time": "5-10分钟", "data": "0.00" },
        { "time": "10-15分钟", "data": "0.00" },
        { "time": "15-30分钟", "data": "0.00" },
        { "time": "30分钟以上", "data": "0.00" },
      ],
      userRank: [],
      worksRank:[],
      areaData: [
              { name: "北京市", short: "北京", value: 1, label: { show: true } },
              { name: "天津市", short: "天津", value: 1, label: { show: true } },
              { name: "河北省", short: "河北", value: 1, label: { show: true } },
              { name: "山西省", short: "山西", value: 1, label: { show: true } },
              { name: "内蒙古自治区", short: "内蒙古", value: 1, label: { show: true } },
              { name: "辽宁省", short: "辽宁", value: 1, label: { show: true } },
              { name: "吉林省", short: "吉林", value: 1, label: { show: true } },
              { name: "黑龙江省", short: "黑龙江", value: 1, label: { show: true } },
              { name: "上海市", short: "上海", value: 1, label: { show: true } },
              { name: "江苏省", short: "江苏", value: 1, label: { show: true } },
              { name: "浙江省", short: "浙江", value: 1, label: { show: true } },
              { name: "安徽省", short: "安徽", value: 1, label: { show: true } },
              { name: "福建省", short: "福建", value: 1, label: { show: true } },
              { name: "江西省", short: "江西", value: 1, label: { show: true } },
              { name: "山东省", short: "山东", value: 1, label: { show: true } },
              { name: "河南省", short: "河南", value: 1, label: { show: true } },
              { name: "湖北省", short: "湖北", value: 1, label: { show: true } },
              { name: "湖南省", short: "湖南", value: 1, label: { show: true } },
              { name: "广东省", short: "广东", value: 1, label: { show: true } },
              { name: "广西壮族自治区", short: "广西", value: 1, label: { show: true } },
              { name: "海南省", short: "海南", value: 1, label: { show: true } },
              { name: "重庆市", short: "重庆", value: 1, label: { show: true } },
              { name: "四川省", short: "四川", value: 1, label: { show: true } },
              { name: "贵州省", short: "贵州", value: 1, label: { show: true } },
              { name: "云南省", short: "云南", value: 1, label: { show: true } },
              { name: "西藏自治区", short: "西藏", value: 1, label: { show: true } },
              { name: "陕西省", short: "陕西", value: 1, label: { show: true } },
              { name: "甘肃省", short: "甘肃", value: 1, label: { show: true } },
              { name: "青海省", short: "青海", value: 1, label: { show: true } },
              { name: "宁夏回族自治区", short: "宁夏", value: 1, label: { show: true } },
              { name: "新疆维吾尔自治区", short: "新疆", value: 1, label: { show: true } },
              { name: "香港特别行政区", short: "香港", value: 1, label: { show: true } },
              { name: "澳门特别行政区", short: "澳门", value: 1, label: { show: true } },
              { name: "台湾省", short: "台湾", value: 1, label: { show: true } },
            ],
            timer: '',
    }
  },
  mounted() {
    this.getInfo()
    // this.timer = setInterval(() => {
    //   this.getInfo()
    // }, 60000);
    this.getTime()
    setInterval(() => {
      this.getTime()
    }, 1000);
  },
  beforeDestroy()
  {
    clearInterval(this.timer)
    this.timer = ''
  },
  methods: {
    getInfo() {
      let name = sessionStorage.getItem(md5("yslt_account")) || localStorage.getItem(md5("yslt_account"))
      let password = sessionStorage.getItem(md5("yslt_password")) || localStorage.getItem(md5("yslt_password"))
      let params = {
        'account': name,
        'password': password
      }
      https.fetchPost('/api/v1/appGallery/info', params).then((data) => {
        if (data.code == 0) {
          this.data = data.result
          let result = data.result
          this.view = this.viewTo
          this.viewTo = Number(result.browseCount)
          this.viewTimes = this.viewTimesTo
          this.viewTimesTo = Number(Number(result.viewDuration / 60).toFixed(0))
          this.share = this.shareTo
          this.shareTo = Number(result.shareCount)
          this.like = this.likeTo
          this.likeTo = Number(result.likeCount)
          this.comment = this.commentTo
          this.commentTo = Number(result.commentCount)

          this.viewTime[0]['data'] = Number(result.count1).toFixed(2)
          this.viewTime[1]['data'] = Number(result.count2).toFixed(2)
          this.viewTime[2]['data'] = Number(result.count3).toFixed(2)
          this.viewTime[3]['data'] = Number(result.count4).toFixed(2)
          this.viewTime[4]['data'] = Number(result.count5).toFixed(2)
          this.viewTime[5]['data'] = Number(result.count6).toFixed(2)

          this.viewNum[0]['data'] = Number(result.view1).toFixed(2)
          this.viewNum[1]['data'] = Number(result.view2).toFixed(2)
          this.viewNum[2]['data'] = Number(result.view3).toFixed(2)
          this.viewNum[3]['data'] = Number(result.view4).toFixed(2)
          this.viewNum[4]['data'] = Number(result.view5).toFixed(2)
          this.viewNum[5]['data'] = Number(result.view6).toFixed(2)

          this.worksRank = result.worksRank
          this.userRank = result.userRank

          let galleryArea = result.galleryArea
          galleryArea.forEach(area => {
            this.areaData.forEach(item => {
              if (area.title.includes(item.short)) {
                item.value = area.count1
              }
            })
          });
          this.map()
        }else {
          this.logout()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    logout() {
      sessionStorage.removeItem(md5("yslt_account"))
      sessionStorage.removeItem(md5("yslt_password"))
      localStorage.removeItem(md5("yslt_password"))
      this.$router.push('/Login')
    },
    getTime() {
      const date = new Date()
      const hours = date.getHours()
      let minutes = date.getMinutes()
      if (minutes < 10) {
        minutes = "0" + minutes
      }
      let seconds = date.getSeconds()
      if (seconds < 10) {
        seconds = "0" + seconds
      }
      this.time = `${hours}:${minutes}:${seconds}`
      const month = date.getMonth() + 1
      const day = date.getDate()
      this.date = `${month}月${day}日`
      const weekDay = date.getDay()
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      this.week = weekDays[weekDay]
    },
    map() {
      let myChart = echarts.init(document.getElementById("mapEchart"))
      echarts.registerMap("china", JSON)
      myChart.hideLoading()

      let option = {
        backgroundColor: '',
        dataRange: {
          calculable: false,
          x: 'right',
          y: 'bottom',
          splitList: [
            { start: 11, label: '高', color: '#F65C5C' },
            { start: 6, end: 10, label: ' ', color: '#FF6A8B' },
            { start: 3, end: 5, label: ' ', color: '#6C8BF3' },
            { start: 1, end: 2, label: ' ', color: '#67C0FF' },
            { start: 0, end: 0, label: '低', color: '#BFD0DC' },
          ],
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: '数量',
            type: "map",
            mapType: "china",
            roam: false,
            zoom: 1.3,
            center: [98.948024, 36.263161],
            selectedMode: "single",
            label: {
              color: "#fff",
              fontSize: 12
            },
            itemStyle: {
              normal: {
                // 地图省份的背景颜色
                areaColor: "rgba(20, 41, 87,0.6)",
                borderColor: 'white'
              },
              emphasis: {
                color: 'red',
                areaColor: "#2B91B7",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 3,
                borderWidth: 0,
                shadowColor: 'raba(0,0,0,0.2)'
              }
            },
            data: this.areaData
          }
        ]
      }
      myChart.setOption(option)
      // 监听浏览器缩放，图表对象调用缩放resize函数
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.container {
  min-height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.top-box {
  max-width: 1920px;
  min-width: 1024px;
  height: 1.575rem
    /* 126/80 */
  ;
  position: relative;

  .top-img {
    width: 100%;
    height: 1.575rem
      /* 126/80 */
    ;
    object-fit: fill;
  }

  .top-info {
    position: absolute;
    top: .225rem
      /* 18/80 */
    ;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 .475rem
      /* 38/80 */
      0 .375rem
      /* 30/80 */
    ;

    .top-left,
    .top-right {
      width: auto;
      cursor: default;
    }

    .top-left {
      display: flex;
      align-items: center;

      >img {
        height: .5rem
          /* 40/80 */
        ;
        width: .5rem
          /* 40/80 */
        ;
        margin-right: .2125rem
          /* 17/80 */
        ;
      }

      >div {
        font-size: .3rem
          /* 24/80 */
        ;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        line-height: 1;
      }
    }

    .top-title {
      font-family: 'siyuan';
      font-size: .425rem
        /* 34/80 */
      ;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 1;
      max-width: 8.75rem;
      overflow: hidden;
      /* 溢出部分进行隐藏 */
      display: -webkit-box;
      -webkit-box-orient: vertical;
      /* 盒模型元素从顶部向底部垂直排列子元素 */
      -webkit-line-clamp: 1;
      /* 显示两行 */
      text-overflow: ellipsis;
      cursor: default;
    }

    .top-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .time {
        font-size: .4rem
          /* 32/80 */
        ;
        font-family: Myriad Pro;
        font-weight: 400;
        color: #fff;
        line-height: 1;
      }

      .date {
        font-size: .15rem
          /* 12/80 */
        ;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        line-height: 1;
        margin-left: .25rem
          /* 20/80 */
        ;
        margin-right: .5875rem
          /* 47/80 */
        ;
      }

      .logout {
        font-size: .25rem;
        color: #fff;
        font-weight: 400;
        border-bottom: 1px solid #fff;
        cursor: pointer;
      }
    }
  }

  .top-desc {
    position: absolute;
    bottom: .475rem
      /* 38/80 */
    ;
    left: 0;
    width: 100%;
    font-size: .15rem
      /* 12/80 */
    ;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }
}

.left-top-data {
  display: flex;
  align-items: center;
  position: fixed;
  top: 1.625rem;
  left: .875rem;



  .top-item {
    display: flex;
    box-sizing: border-box;
    margin-right: .95rem;
    min-width: 2.5rem;

    .item-left {
      margin-right: .175rem;

      >img {
        height: .4625rem;
        width: auto;
      }
    }

    .item-right {
      font-size: .2rem
        /* 16px -> .2rem */
      ;
      font-weight: 400;
      color: #fff;
      text-align: left;

      .right-head {
        font-size: .25rem;
        font-weight: bold;
        height: .4625rem
          /* 37px -> .4625rem */
        ;
        line-height: .4625rem
          /* 37px -> .4625rem */
        ;
      }

      .right-data {
        margin-top: .125rem;
        opacity: 0.7;
      }

      .strong {
        font-size: .5rem;
        color: #fff;
      }
    }
  }
}

.left-mid-data {
  display: flex;
  align-items: center;
  position: fixed;
  top: 3.3125rem;
  left: .875rem;

  .mid-item {
    margin-right: .75rem
      /* 60px -> .75rem */
    ;
    display: flex;
    align-items: center;
    font-size: .175rem
      /* 12px -> .15rem */
    ;
    color: rgba(255, 255, 255, 0.7);
    font-weight: 400;

    >img {
      height: .5125rem
        /* 41px -> .5125rem */
      ;
      width: auto;
      margin-right: .3125rem
        /* 25px -> .3125rem */
      ;
    }

    .strong {
      margin: 0 .1rem
        /* 8px -> .1rem */
      ;
      font-size: .3rem
        /* 24px -> .3rem */
      ;
      font-family: Myriad Pro;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.7);
    }
  }
}

.left-bottom-data {
  position: fixed;
  bottom: .75rem;
  left: .875rem;
  width: 5.4375rem;

  .rank-content {
    margin-top: .1625rem;
    padding: 0 .4rem;
    box-sizing: border-box;

    .rank-item {
      width: 100%;
      box-sizing: border-box;
      height: .5rem;
      display: flex;
      align-items: center;

      >img {
        padding-top: .0875rem;
        height: .4rem;
        width: .7875rem;
      }

      .provide {
        flex: 1;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        font-size: .175rem;
        text-align: left;
        padding-left: .0875rem;
        opacity: 0.6;
      }

      .data {
        font-size: .2rem;
        font-family: Myriad Pro;
        color: white;
        opacity: 0.6;
      }
    }
  }

}


.right-top-data {
  position: fixed;
  top: 1.25rem;
  right: .925rem;
  width: 6.625rem;

  .right-top-content::-webkit-scrollbar {
  display: none;
}
  .right-top-content {
    margin: .1625rem .4rem 0;
    padding: 0 .25rem 0 .175rem;
    box-sizing: border-box;
    max-height: 3.5rem;
    overflow-y: scroll;
    background-color: rgba(103, 192, 255, 0.1);
    border-radius: 0.075rem;
    -ms-overflow-style: none;  /* IE 和 Edge */
  scrollbar-width: none;  /* Firefox */

    .content-item {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      text-align: left;
      padding: .15rem 0;

      .index {
        color: #fff;
        font-size: .25rem;
        font-weight: 400;
        width: .375rem;
        text-align: right;
      }

      >img {
        height: .5rem;
        width: .75rem;
        object-fit: cover;
        margin-left: .3125rem;
      }
      .avatar {
        width: .5rem;
        height: .5rem;
        border-radius: .75rem;
      }

      .title {
        font-size: .2rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fff;
        margin-left: .1625rem;
      }

      .hot {
        font-size: .2rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #fff;
        flex: 1;
        text-align: right;
      }
    }
  }

  .comment {
    padding: .2rem .3375rem 0;

    .comment-item {
      display: flex;
      align-items: flex-start;
      box-sizing: border-box;

      >img {
        height: .6rem;
        width: .6rem;
        border-radius: .6rem;
      }

      .comment-content {
        margin-top: .225rem;
        margin-left: .2rem;

        .comment-title {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .name {
            font-size: .175rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(255, 255, 255, 0.7);
            ;
          }

          .time {
            font-size: .175rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.7);
            ;
          }
        }

        .comment-text {
          margin-top: .1rem;
          padding: .1875rem;
          border-radius: 0px .075rem .075rem .075rem;
          background-color: rgba(103, 192, 255, 0.1);
          font-size: .175rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fff;
          line-height: 1.6;
          text-align: left;
        }
      }
    }
  }
}

.left-bottom-data {
  position: fixed;
  right: .925rem;
  bottom: .75rem;
  width: 6.25rem;

  .data-content {
    display: flex;
    align-items: flex-start;
    padding: .2rem .35rem 0;

    >div {
      width: 50%;
      margin-right: .25rem;
      box-sizing: border-box;
    }

    .data-item {
      text-align: left;

      .item-title {
        height: .3rem;
        line-height: .3rem;
        width: .8875rem;
        background: rgba(254, 255, 255, 0.1);
        border-radius: 2px 12px 12px 2px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        font-size: .175rem;
        text-align: center;
      }

      .item-content {
        margin-top: .2875rem;

        .item-box:not(:first-child) {
          margin-top: .225rem;
        }

        .item-box {
          display: flex;
          align-items: center;
          box-sizing: border-box;

          .num {
            text-align: left;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fff;
            font-size: .15rem;
            opacity: 0.6;
          }

          .data {
            width: .625rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fff;
            font-size: .15rem;
            margin: 0 .2125rem;
            opacity: 0.6;
          }

          .bar-box {
            flex: 1;
            height: .125rem;

            .bar {
              height: .125rem;
              border-radius: 5px;
            }

            .bar0 {
              background: #6C8BF3;
            }

            .bar1 {
              background: #67C0FF;
            }

            .bar2 {
              background: #57D4DB;
            }

            .bar3 {
              background: #57D4DB;
            }

            .bar4 {
              background: #BFE9DA;
            }

            .bar5 {
              background: #D5E4EE;
            }
          }
        }
      }
    }
  }
}

.bottom-box {
  max-width: 1920px;
  min-width: 1024px;
  width: 100%;
  font-size: 0;
  position: fixed;
  bottom: 0;
  left: 0;

  .bottom-img {
    width: 100%;
    height: .85rem
      /* 68/80 */
    ;
  }

  .bottom-menu-box {
    position: absolute;
    width: 100%;
    bottom: .1375rem
      /* 11/80 */
    ;
    left: 0;

    .bottom-menu {
      margin: 0 auto;
      width: 4.3rem
        /* 344/80 */
      ;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .menu-item {
        position: relative;
        width: 1.25rem
          /* 100/80 */
        ;

        a {
          text-decoration: none;
          display: block;
        }

        img {
          height: .5rem
            /* 40/80 */
          ;
          width: .5rem
            /* 40/80 */
          ;
        }

        div {
          margin-top: .0875rem
            /* 7/80 */
          ;
          font-size: .2rem
            /* 16/80 */
          ;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #506676;
          margin-top: .0875rem
            /* 7/80 */
          ;
          opacity: 0.7;
        }
      }

      .active {
        >img {
          position: absolute;
          left: 0;
          bottom: .1rem
            /* 8/80 */
          ;
          height: 1.25rem
            /* 100/80 */
            !important;
          width: 1.25rem
            /* 100/80 */
            !important;
        }

        >div {
          font-weight: bold !important;
          color: rgb(0, 18, 79) !important;
        }
      }
    }
  }
}

.map-chart {
  position: absolute;
  bottom: .75rem;
  left: 1.25rem;
  height: 10.75rem;
  width: 15rem;
}

.data-box {
  border: 1px solid rgba(25, 186, 139, 0.17);
  background: rgba(255, 255, 255, 0.04) url(../assets/line.png);
  padding: .25rem 0;

  .data-header {
    padding-bottom: .2rem;
    margin: 0 .4375rem;
    font-size: .2rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    display: flex;
    align-items: flex-end;
    border-bottom: .0125rem solid rgba(116, 172, 255, 0.42);

    >span {
      margin-left: .1rem;
      font-size: .1375rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #fff;
    }
  }

  .content-header {
    padding: .2rem 0 0 .3375rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
    font-size: .175rem;
    text-align: left;
    display: flex;
    align-items: center;

    >img {
      height: .45rem;
      width: auto;
      margin-right: .15rem;
      opacity: 0.5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserData.vue